import { EmailTemplate } from "../../types/EmailTemplate";

export const TemplateAnnouncement: EmailTemplate = {
  id: "announcement",
  name: "Annonce / Alerte",
  description: "Communication importante avec bandeau coloré (info, alerte ou succès)",
  templateFile: "announcement",
  previewData: {
    alertType: "info",
    title: "Mise à jour de nos services",
    message:
      "Nous améliorons continuellement IZI LIFE PAY pour vous offrir une meilleure expérience.<br><br>Consultez l'application pour découvrir les nouveautés.",
    ctaText: "Ouvrir l'application",
    ctaUrl: "https://izilifepay.com",
  },
  fields: [
    {
      name: "alertType",
      label: "Type d'alerte",
      type: "select",
      required: true,
      defaultValue: "info",
      options: [
        { value: "info", label: "Information (bleu)" },
        { value: "warning", label: "Important (orange)" },
        { value: "success", label: "Bonne nouvelle (vert)" },
      ],
    },
    {
      name: "title",
      label: "Titre",
      type: "text",
      required: true,
      placeholder: "Ex: Maintenance programmée",
      defaultValue: "Annonce importante",
    },
    {
      name: "message",
      label: "Message",
      type: "textarea",
      required: true,
      placeholder: "Détails de l'annonce...",
    },
    {
      name: "ctaText",
      label: "Texte du bouton",
      type: "text",
      required: false,
      placeholder: "Ex: En savoir plus",
    },
    {
      name: "ctaUrl",
      label: "Lien du bouton",
      type: "url",
      required: false,
      placeholder: "https://...",
    },
  ],
};
